import React from 'react'
import FaIcon from "../Elements/FaIcon";
import PlanningStatusEnum from '../Enums/PlanningStatusEnum';
import stringHelper from './stringHelper';

export class statusHelper
{
	static getPlanningStatusColorClassName(status)
	{
		let res=" planningStatus"+status;
		return res;
	}

	static getStatusColorIcon(status)
	{
        let cn=statusHelper.getPlanningStatusColorClassName(status);
        
        if(status==="Waiting...")
        {
            return (<FaIcon iconName="fa-solid fa-pause" className="text-warning"/>);
        }


		return(
			<FaIcon className={cn}/>
		);
	}

	static getToSelectValues()
    {
        let values= [
            {label: PlanningStatusEnum.Created, value: PlanningStatusEnum.Created, disabled: false},
            {label: PlanningStatusEnum.ClientConfirmed, value: PlanningStatusEnum.ClientConfirmed, disabled: false},
            {label: PlanningStatusEnum.OnHold, value: PlanningStatusEnum.OnHold, disabled: false},
            {label: PlanningStatusEnum.Closed, value: PlanningStatusEnum.Closed, disabled: false},
            {label: PlanningStatusEnum.Cancelled, value: PlanningStatusEnum.Cancelled, disabled: false},
        ]
        return values;
    }

    static getFromInfo(newStatus)
    {
        let statusInReality=(
            newStatus===PlanningStatusEnum.Created||newStatus===PlanningStatusEnum.ClientConfirmed
            ? "Created or Client Confirmed (depends on their properties)"
            : stringHelper.convertToWords(newStatus)
        );
        let result="";
        switch (newStatus) {
            case PlanningStatusEnum.Created:
                result= "On Hold, Cancelled";
                break;
            case PlanningStatusEnum.ClientConfirmed:
                result= "On Hold, Cancelled";
                break;
            case PlanningStatusEnum.Closed:
                result= "Client Confirmed";
                break;
            case PlanningStatusEnum.OnHold:
                result= "Created, Client Confirmed, Cancelled";
                break;
            case PlanningStatusEnum.Cancelled:
                result= "Created, Client Confirmed, On Hold";
                break;
        
            default:
                break;
        }
		return(
			<>
                {"The following statuses will change to "+statusInReality+": "}
                <br/>
                {result}
            </>
		);
    }
}

export default statusHelper;